webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/*
DRY up Prismic code
 */
var Prismic, PrismicDOM;

Prismic = __webpack_require__(3);

PrismicDOM = __webpack_require__(5);

module.exports = {
  typeIs: function(type) {
    return Prismic.Predicates.at('document.type', type);
  },
  textOf: function(attribute) {
    return PrismicDOM.RichText.asText(attribute);
  }
};


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/*
Webpack has issues generating css source maps with scss files that are in the
same directory as entry js.  So this entry file dials out to modules in sub
directories to work around this.
 */
var Vue, router;

Vue = __webpack_require__(0);

router = __webpack_require__(10);

__webpack_require__(25);

new Vue({
  el: '#app',
  router: router,
  render: function(create) {
    return create(__webpack_require__(26));
  }
});


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/*
Init the Vue Router
 */
var Vue, VueRouter, router, routes;

Vue = __webpack_require__(0);

VueRouter = __webpack_require__(11)["default"];

routes = __webpack_require__(12);

Vue.use(VueRouter);

router = new VueRouter({
  base: '/',
  mode: 'history',
  routes: routes
});

module.exports = router;


/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/*
Route definitions for the whole app for consumption by vue-router
 */
module.exports = [
  {
    name: 'home',
    path: '/',
    component: __webpack_require__(13)
  }, {
    name: 'organization',
    path: '/:organization',
    component: __webpack_require__(18)
  }
];


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(14)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = __webpack_require__(16)
/* template */
var __vue_template__ = __webpack_require__(17)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports) {




/***/ }),
/* 17 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-home"},[_c('h1',{staticClass:"title"},[_vm._v("Bukwild.Show")])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = __webpack_require__(20)
/* template */
var __vue_template__ = __webpack_require__(24)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var PrismicDOM, prismic, textOf;

prismic = __webpack_require__(21);

textOf = __webpack_require__(4).textOf;

PrismicDOM = __webpack_require__(5);

module.exports = {
  data: function() {
    return {
      org: null
    };
  },
  created: function() {
    return this.getOrganization();
  },
  methods: {
    getOrganization: function() {
      return prismic((function(_this) {
        return function(api) {
          return api.getByUID('organization', _this.$route.params.organization);
        };
      })(this)).then((function(_this) {
        return function(response) {
          return _this.org = response.data;
        };
      })(this));
    }
  }
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/*
Accept a callback function that will recieve an instance of the api

Usage:
  prismic = require '@/services/prismic/api'
  module.exports =
    data: -> cms: null
    created: ->
      prismic (api) -> api.getSingle 'homepage'
      .then (response) => @cms = response.data
 */
var Prismic, endpoint;

Prismic = __webpack_require__(3);

endpoint = 'https://bukwild-show.prismic.io/api/v2';

module.exports = function(cb) {
  return Prismic.getApi(endpoint).then(function(api) {
    return cb(api);
  });
};


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.org)?_c('div',{staticClass:"organization"},[_c('a',{staticClass:"title-bar",attrs:{"href":_vm.org.instagram.url,"target":"_blank"}},[(_vm.org.logo.url)?_c('div',{staticClass:"logo",style:({'background-image': 'url('+ _vm.org.logo.url +')'})}):_vm._e(),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("prismicText")(_vm.org.title)))])]),_c('div',{staticClass:"divider"}),_c('div',{staticClass:"link-list"},_vm._l((_vm.org.links),function(link){return _c('a',{staticClass:"link",style:({'background-image': 'url('+ link.image.url +')'}),attrs:{"href":link.link.url,"target":"_blank"}})}))]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/*
Make Vue filters
 */
var Vue, textOf;

Vue = __webpack_require__(0);

textOf = __webpack_require__(4).textOf;

Vue.filter('prismicText', textOf);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = __webpack_require__(28)
/* template */
var __vue_template__ = __webpack_require__(29)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {




/***/ }),
/* 29 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.7583d70ecfed42ef0b69.js